module.exports = __webpack_public_path__ + "static/US-25-Cent-dd330cba4c8c8246c9d799082e3292d9.png";